<template>
  <div class="addactivities">
    <div style="padding-top:5%; ">
    <!-- <div class="page-header"> -->
    <div>
      <h1>活動登錄</h1>

    </div>
    <div class="panel panel-default">
            <div class="mb-3 panel-body" style="padding: 3% 30% 5% 30%; text-align:left;">
              <ValidationObserver ref="observer">
                <form class="form" slot-scope="{ validate }" @submit.prevent="validate().then(addActivity)">
                  <ValidationProvider rules="required|alpha" name="申請人">
                    <div class="form-group" slot-scope="{ valid, errors }" label="acName">
                        <label for="acName">申請人：</label>
                        <input type="text" v-model="name" :state="errors[0] ? false : (valid ? true : null)">
                        <form-invalid-feedback class="text-danger">{{ errors[0] }}</form-invalid-feedback>
                    </div>
                    </ValidationProvider>
                    <ValidationProvider rules="required|alpha" name="職稱">
                    <div class="form-group" slot-scope="{ valid, errors }" label="acTitle">
                        <label for="acTitle">職稱：</label>
                        <input type="text" v-model="title" :state="errors[0] ? false : (valid ? true : null)">
                        <form-invalid-feedback class="text-danger">{{ errors[0] }}</form-invalid-feedback>
                    </div>
                  </ValidationProvider>
                    <ValidationProvider rules="required|email" name="Email">
                    <div class="form-group" slot-scope="{ valid, errors }"
          label="acEmail">
                        <label for="acEmail">Email：</label>
                        <input type="email" v-model="email" :state="errors[0] ? false : (valid ? true : null)">
                        <form-invalid-feedback class="text-danger">{{ errors[0] }}</form-invalid-feedback>
                    </div>
                    </ValidationProvider>
                    <ValidationProvider rules="required|alpha" name="主辦單位">
                    <div class="form-group" slot-scope="{ valid, errors }" label="acHost">
                        <label for="acHost">主辦單位：</label>
                        <input type="text" v-model="host" :state="errors[0] ? false : (valid ? true : null)">
                        <form-invalid-feedback class="text-danger">{{ errors[0] }}</form-invalid-feedback>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider rules="required" name="活動名稱">
                    <div class="form-group" slot-scope="{ valid, errors }" label="acActivity_name">
                        <label for="acActivity_name">活動名稱：</label>
                        <input type="text" v-model="activity_name" :state="errors[0] ? false : (valid ? true : null)">
                        <form-invalid-feedback class="text-danger">{{ errors[0] }}</form-invalid-feedback>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider rules="required" name="活動網址">
                    <div class="form-group" slot-scope="{ valid, errors }" label="acUrl">
                        <label for="acUrl">活動網址：</label>
                        <input type="text" v-model="url" :state="errors[0] ? false : (valid ? true : null)" >
                        <form-invalid-feedback class="text-danger">{{ errors[0] }}</form-invalid-feedback>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider rules="required" name="活動時間">
                    <div class="form-group" slot-scope="{ valid, errors }" label="acStartdate">
                        <label for="acStartdate">活動時間：</label>
                        <div>
                            <date-picker format="YYYY/MM/DD" id="acStartdate" value-type="format" v-model="date" :editable="false" range required></date-picker>
                        </div>
                        <form-invalid-feedback class="text-danger">{{ errors[0] }}</form-invalid-feedback>
                    </div>
                  </ValidationProvider>
                    <div class="form-group">
                        <label for="acSaying">我有話想說</label>
                        <textarea type="text" class="form-control" v-model="saying"></textarea>
                    </div>
                    <button type="submit" class="btn btn-primary" @click="addActivity" :disabled="invalid">送出</button>
                </form>
              </ValidationObserver>
                <h6 style="text-align:right;">*如有任何問題請與 shihshuanwu@ntnu.edu.tw 聯繫</h6>
            </div>
        </div>
    <!-- <b-button @click="logout" variant="outline-danger" class="btn btn-lg">
      <icon name="sign-out-alt"></icon> Log out</b-button> -->
  </div>
</div>
</template>

<script>
// import firebase from 'firebase'
import { db } from '../main'
// import toastr from 'toastr'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-tw'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
// let oaActivitiesRef = db.ref('oaActivities')

export default {
  name: 'addActivities',
  components: {
    DatePicker,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      oaActivities: [],
      name: '',
      host: '',
      title: '',
      startdate: '',
      date: '',
      enddate: '',
      activity_name: '',
      url: '',
      saying: '',
      email: ''
    }
  },
  firestore () {
    return {
      oaActivities: db.collection('oaActivities')
    }
  },
  methods: {
    addActivity: function () {
      this.$firestore.oaActivities.add({
        name: this.name,
        host: this.host,
        title: this.title,
        date: this.date,
        startdate: this.date[0],
        enddate: this.date[1],
        activity_name: this.activity_name,
        url: this.url,
        saying: this.saying,
        email: this.email,
        timestamp: new Date()
      })
      this.$router.push('/activities')
      this.name = ''
      this.host = ''
      this.title = ''
      this.startdate = ''
      this.date = ''
      this.enddate = ''
      this.activity_name = ''
      this.url = 'http://'
      this.saying = ''
      this.email = ''
    },
    deleteTask: function (oaActivities) {
      this.$firestore.oaActivities.doc(oaActivities['.key']).delete()
    }
  }
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.addactivities {
  background-color: rgba(248, 194, 88,0.1);
}

/*html,body{
  height:100%;
  display: flex;
  justify-content: center;
  align-items: center;
}*/
.login1 {
  margin-top: 100px;
  margin-bottom: 100px;
  width: 500px;
  height: 400px;
  background-color: rgba(#FFFFFF);
  border-radius: 10px;
  /*border: 5px solid #fff;*/
  box-shadow: 0 0 25px #aaa;
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
}
label {
  font-weight:400;
  font-size:large;
}
table {
  font-weight:400;
  font-size:large;
}
.form {

  /*color: #fff;*/
}

.form h2 {
  margin-bottom: 20px;
  padding-bottom: 20px;
  /*border-bottom: 1px solid #fff;*/
}

.form .group {
  margin-bottom: 20px;
}

.form label {

  line-height: 2;

}

.form input {
  width: 100%;
  border: 1px solid #aaa;
  line-height: 3;
  border-radius: 5px;
}

.form .btn-group {
  font-size: 0;
}

.btn1 {
  font-size: 20px;
  border-radius: 10px;
  border: none;
  background-color: #6ab4fe;
  width: 190px;
  padding: 10px 0;
  color: #fff;
  /*margin-left: 20px;*/

}

.form .btn+.btn {
  margin-left: 20px;
}

</style>
